import api from "./index";

/**
 * Service API pour la gestion des raccourcis personnalisables
 */

/**
 * Récupère les raccourcis existants pour un utilisateur
 * @param {number} customerId - ID du client
 * @returns {Promise} Réponse API avec les raccourcis
 */
export const getShortcuts = async customerId => {
  try {
    const response = await api.get(`/shortcuts/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des raccourcis:", error);
    throw error;
  }
};

/**
 * Sauvegarde les raccourcis pour un utilisateur
 * @param {number} customerId - ID du client
 * @param {Array} shortcuts - Tableau de 3 éléments (raccourcis ou null)
 * @returns {Promise} Réponse API
 */
export const saveShortcuts = async (customerId, shortcuts) => {
  try {
    const response = await api.put(`/shortcuts/${customerId}`, {
      value: shortcuts,
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la sauvegarde des raccourcis:", error);
    throw error;
  }
};
